import { where } from "firebase/firestore";
import { default as Moment, default as moment } from 'moment';
import { getRevenda } from '../../config/auth';
import { Collection, WhereField } from '../../shared/constants';
import { addDoc, getAllDocsByClientId, getAllDocsByCollection, getAllDocsByQueries, getCountByQueries, getDocByQueries, updateDoc } from './collectionBaseWorker';

export const addLicenca = async ({ clienteId, estacionamentoId, revendaId }) => {
    const revenda = getRevenda()
    const data = {
        clienteId: clienteId,
        estacionamentoId: estacionamentoId,
        revendaId: revendaId ?? revenda.id,
        vencimento: Moment().add(revenda?.diasDeTeste ?? 7, 'days').toDate()
    }
    const doc = await addDoc({ collection: Collection.LICENCE, data: data })
    return doc.id
}

export const getLicencas = async ({ clientId }) => {
    const docs = await getAllDocsByClientId({ collection: Collection.LICENCE, clienteId: clientId })
    return docs
}

export const getAllLicencasByRevendaId = async ({ revendaId }) => {
    const quantity = await getCountByQueries({
        collection: Collection.LICENCE,
        queries: [
            where(WhereField.REVENDAID, "==", revendaId),
            where(WhereField.STATUS, "in", ["PAYED", "GENERATED"])
        ]
    })
    return quantity
}

export const getAllLicencas = async () => {
    const docs = await getAllDocsByCollection({ collection: Collection.LICENCE })
    return docs
}

export const getAllLicencasByClienteId = async ({ clienteId }) => {
    return await getAllDocsByClientId({ collection: Collection.LICENCE, clienteId: clienteId })
}

export const getAllLicencaByParksIds = async ({ ids }) => {
    const items = await getAllDocsByQueries({
        collection: Collection.LICENCE,
        queries: [
            where(WhereField.PARKID, 'in', ids)
        ]
    })
    var results = []
    for (const item of items) {
        const vencimento = moment(item.vencimento.seconds * 1000)
        const today = moment()
        if (item.status) {
            if (item.status !== "PAYED" && item.status !== "CANCELED" && vencimento.isSameOrAfter(today)) {
                item.status = "PENDING"
            }
        } else {
            item.status = "FREE"
        }
        item.vencimentoFormatted = vencimento.format("DD/MM/YYYY")
        results.push(item)
    }
    return results
}

export const getLicencaByParkId = async ({ estacionamentoId }) => {
    const data = await getDocByQueries({
        collection: Collection.LICENCE,
        queries: [
            where(WhereField.PARKID, '==', estacionamentoId)
        ]
    })
    if (data) {
        const vencimento = moment(data.vencimento.seconds * 1000)
        const today = moment()
        if (data.status) {
            if (data.status !== "PAYED" && data.status !== "CANCELED" && vencimento.isSameOrAfter(today)) {
                data.status = "PENDING"
            }
        } else {
            data.status = "FREE"
        }
        data.vencimentoFormatted = vencimento.format("DD/MM/YYYY")
        return data
    }
    return null
}

export const getAllLicencesByClientId = async ({ clienteId }) => {
    const items = await getAllDocsByQueries({
        collection: Collection.LICENCE,
        queries: [
            where(WhereField.CLIENTEID, '==', clienteId)
        ]
    })
    var results = []
    for (const item of items) {
        const vencimento = moment(item.vencimento.seconds * 1000)
        const today = moment()
        if (item.status) {
            if (item.status !== "PAYED" && item.status !== "CANCELED" && vencimento.isSameOrAfter(today)) {
                item.status = "PENDING"
            }
        } else {
            item.status = "FREE"
        }
        item.vencimentoFormatted = vencimento.format("DD/MM/YYYY")
        results.push(item)
    }
    return results
}

export const updateLicenceRevendaId = async ({ id, revendaId }) => {
    await updateDoc({ collection: Collection.LICENCE, id: id, data: { revendaId: revendaId } })
}

export const updateLicenceById = async ({ id, data }) => {
    await updateDoc({ collection: Collection.LICENCE, id: id, data: data })
}